import { useStateWithBrowserStorage } from '@farmersdog/utils';

const TERMS_ACCEPTANCE_KEY = 'terms-and-conditions-acceptance';

export function useTermsAcceptance() {
  return useStateWithBrowserStorage<boolean>(
    false,
    TERMS_ACCEPTANCE_KEY,
    'localStorage'
  );
}
